import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

/**
 * Footer component for the BagABoard application.
 * 
 * This component provides the site footer with links, contact information,
 * and company details. It's displayed at the bottom of every page.
 * 
 * @author BagABoard Team
 */
function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer bg-dark text-light">
      <Container>
        <Row>
          {/* Company Information */}
          <Col md={4} className="mb-4">
            <h5 className="mb-3">
              <i className="fas fa-suitcase-rolling me-2"></i>
              BagAboard
            </h5>
            <p className="text-muted">
              Your trusted partner for worldwide luggage shipping. 
              Safe, reliable, and affordable bag delivery services.
            </p>
            <div className="d-flex gap-3">
              <a href="#" className="text-muted">
                <i className="fab fa-facebook fa-lg"></i>
              </a>
              <a href="#" className="text-muted">
                <i className="fab fa-twitter fa-lg"></i>
              </a>
              <a href="#" className="text-muted">
                <i className="fab fa-instagram fa-lg"></i>
              </a>
              <a href="#" className="text-muted">
                <i className="fab fa-linkedin fa-lg"></i>
              </a>
            </div>
          </Col>

          {/* Quick Links */}
          <Col md={2} className="mb-4">
            <h5 className="mb-3">Services</h5>
            <ul className="list-unstyled">
              <li><a href="/book">Book Shipping</a></li>
              <li><a href="/track">Track Package</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#insurance">Insurance</a></li>
            </ul>
          </Col>

          {/* Support Links */}
          <Col md={2} className="mb-4">
            <h5 className="mb-3">Support</h5>
            <ul className="list-unstyled">
              <li><a href="/about">About Us</a></li>
              <li><a href="/contact">Contact</a></li>
              <li><a href="#faq">FAQ</a></li>
              <li><a href="#help">Help Center</a></li>
            </ul>
          </Col>

          {/* Legal Links */}
          <Col md={2} className="mb-4">
            <h5 className="mb-3">Legal</h5>
            <ul className="list-unstyled">
              <li><a href="#terms">Terms of Service</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#shipping">Shipping Policy</a></li>
              <li><a href="#refund">Refund Policy</a></li>
            </ul>
          </Col>

          {/* Contact Information */}
          <Col md={2} className="mb-4">
            <h5 className="mb-3">Contact</h5>
            <ul className="list-unstyled text-muted">
              <li className="mb-2">
                <i className="fas fa-phone me-2"></i>
                +1 (555) 123-4567
              </li>
              <li className="mb-2">
                <i className="fas fa-envelope me-2"></i>
                support@bagaboard.com
              </li>
              <li className="mb-2">
                <i className="fas fa-clock me-2"></i>
                24/7 Support
              </li>
            </ul>
          </Col>
        </Row>

        {/* Footer Bottom */}
        <Row className="footer-bottom pt-3 mt-4 border-top">
          <Col md={6}>
            <p className="mb-0 text-muted">
              © {currentYear} BagAboard. All rights reserved.
            </p>
          </Col>
          <Col md={6} className="text-md-end">
            <p className="mb-0 text-muted">
              Made with <i className="fas fa-heart text-danger"></i> for travelers worldwide
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
